// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5r-1";
export var standaloneTable = "_5r-0";